import axios from 'axios';

const API_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchDistricts = async () => {
  try {
    const response = await axios.get(`${API_URL}/api/districts`);
    return response.data;
  } catch (error) {
    console.error('Error fetching districts:', error);
    throw error;
  }
};

export const createDistrict = async (formData) => {
  try {
    const response = await axios.post(`${API_URL}/api/districts`, formData, {
      headers: {
        // Let axios set Content-Type automatically for FormData
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error creating district:', error);
    throw error;
  }
};

export const updateDistrict = async (id, formData) => {
  try {
    const response = await axios.put(`${API_URL}/api/districts/${id}`, formData, {
      headers: {
        // Let axios set Content-Type automatically for FormData
      },
    });

    return response.data;
  } catch (error) {
    console.error('Error updating district:', error);
    throw error;
  }
};

export const deleteDistrict = async (id) => {
  try {
    const response = await axios.delete(`${API_URL}/api/districts/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting district:', error);
    throw error;
  }
};

export const fetchCompanies = async () => {
  try {
    const response = await axios.get(`${API_URL}/api/companies`);
    return response.data;
  } catch (error) {
    console.error('Error fetching companies:', error);
    throw error;
  }
};

export const fetchCompaniesByCity = async (city) => {
  try {
    const response = await axios.get(`${API_URL}/api/companies/bycity?city=${encodeURIComponent(city)}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching companies by city:', error);
    throw error;
  }
};

export const fetchCompaniesByIndustry = async (industry) => {
  try {
    const response = await axios.get(`${API_URL}/api/companies/byindustry?industry=${encodeURIComponent(industry)}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching companies by industry:', error);
    throw error;
  }
};